module.exports = __webpack_public_path__ + "img/member-icon1.f2d322fb.png";